/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useNavigate} from 'react-router-dom'
import {Button, Dropdown} from 'react-bootstrap'
import {IncomeDocumentStateTypes, IncomeDocumentTypes} from '../../../constants/Common'
import {updateIncomeDocument} from '../../../api/RevenueApi'
import StateLabel from '../../../components/grid/StateLabel'
import {find, includes} from 'lodash'
import {IIncomeDocument} from '../../../components/app/IncomeDocumentDetailPage'
import {useAuth} from '../../auth'
import {KTIcon} from '../../../../_metronic/helpers'
import api from '../../../utils/Api'
import useConfirmDialog from '../../../hook/useConfirmDialog'

interface IStateActionGroup {
  data: any
}

const StateActionGroup: React.FC<IStateActionGroup> = (props) => {
  const {can} = useAuth()
  const canCreateOrEdit = can('accounting_purchase_order_create') || can('accounting_purchase_order_edit')
  const navigate = useNavigate()
  const {confirm, dialogElement} = useConfirmDialog()
  if (!props?.data) return <></>

  const updateState = (nextState: IncomeDocumentStateTypes, nextPage: string) => {
    updateIncomeDocument(props.data.id, {state: nextState}, () => navigate(nextPage))
  }

  const handleCancelDocument = () => {
    if (!can('accounting_purchase_order_edit')) return
    const code = props.data?.code ? ` (${props.data.code})` : ''
    if (!window.confirm(`ยืนยันยกเลิกเอกสาร${code} ?`)) return
    updateState(IncomeDocumentStateTypes.VOIDED, '/expense-purchase-order/voided')
  }

  const checkPurchaseInventoryRecord = (id: number) => {
    api.request(`account/income-document/${id}/check-creating-purchase-record`, (res: any, success: boolean) => {
      if (success && res?.message?.toLowerCase().includes('ok')) {
        navigate(`/expense-purchase-inventory-record/${id}/edit?fromOrder=true`)
        return
      }

      // API แจ้งว่าบันทึกซื้อครบแล้ว = สถานะถูกอัปเดตเป็น "ออกครบแล้ว" ไปแล้วในรีเควสต์เดียวกัน
      // จึงพาไปแท็บที่เอกสารย้ายไปอยู่จริง ไม่ให้เห็นเอกสารค้างอยู่แท็บเดิม
      const errorMessage = res?.response?.data?.message || ''
      if (errorMessage.includes('ครบแล้ว')) {
        navigate('/expense-purchase-order/completely')
      }
    }, {}, 'POST')
  }

  const linkingDocItemsLength = props.data?.linkingDocument?.incomeDocumentItems?.length || 0
  const currentIssuedLength = props.data?.linkingDocument?.childrenDocuments?.length || 0
  const isAllIssued = linkingDocItemsLength - currentIssuedLength === 0

  switch (props.data.state) {
    case IncomeDocumentStateTypes.DRAFT:
      return (
        <Dropdown>
          <Dropdown.Toggle
            as='a'
            bsPrefix=' '
            className='btn btn-light btn-active-light-primary btn-sm d-inline-flex align-items-center gap-1'
          >
            Actions
            <KTIcon iconName='down' className='fs-5 m-0' />
          </Dropdown.Toggle>
          <Dropdown.Menu renderOnMount popperConfig={{strategy: 'fixed'}}>
            {can('accounting_purchase_order_approve') && (
              <Dropdown.Item
                onClick={() => {
                  updateState(IncomeDocumentStateTypes.APPROVED, '/expense-purchase-order/approved')

                  if (isAllIssued) {
                    updateIncomeDocument(
                      props.data?.linkingDocumentId,
                      {state: IncomeDocumentStateTypes.COMPLETELY},
                      () => {}
                    )
                  }
                }}
              >
                {'อนุมัติ'}
              </Dropdown.Item>
            )}
            {canCreateOrEdit && (
              <Dropdown.Item
                onClick={() =>
                  updateState(
                    IncomeDocumentStateTypes.AWAIT_APPROVAL,
                    '/expense-purchase-order/await-approval'
                  )
                }
              >
                {'ส่งอนุมัติ'}
              </Dropdown.Item>
            )}
            {canCreateOrEdit && (
              <Dropdown.Item
                onClick={() => navigate(`/expense-purchase-order/${props.data.id}/edit`)}
              >
                {'แก้ไข'}
              </Dropdown.Item>
            )}
            {can('accounting_purchase_order_edit') && (
              <Dropdown.Item className='text-danger' onClick={handleCancelDocument}>
                {'ยกเลิกเอกสาร'}
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      )
    case IncomeDocumentStateTypes.AWAIT_APPROVAL:
      return (
        <Dropdown>
          <Dropdown.Toggle
            as='a'
            bsPrefix=' '
            className='btn btn-light btn-active-light-primary btn-sm d-inline-flex align-items-center gap-1'
          >
            Actions
            <KTIcon iconName='down' className='fs-5 m-0' />
          </Dropdown.Toggle>
          <Dropdown.Menu renderOnMount popperConfig={{strategy: 'fixed'}}>
            {can('accounting_purchase_order_approve') && (
              <Dropdown.Item
                onClick={() => {
                  updateState(IncomeDocumentStateTypes.APPROVED, '/expense-purchase-order/approved')

                  if (isAllIssued) {
                    updateIncomeDocument(
                      props.data?.linkingDocumentId,
                      {state: IncomeDocumentStateTypes.COMPLETELY},
                      () => {}
                    )
                  }
                }}
              >
                {'อนุมัติ'}
              </Dropdown.Item>
            )}
            {can('accounting_purchase_order_approve') && (
              <Dropdown.Item
                className='text-danger'
                onClick={() => {
                  confirm({message: 'ยืนยันการไม่อนุมัติ?'}).then((ok) => { if (ok) updateState(IncomeDocumentStateTypes.VOIDED, '/expense-purchase-order/voided') })
                }}
              >
                {'ไม่อนุมัติ'}
              </Dropdown.Item>
            )}
            {can('accounting_purchase_order_edit') && (
              <Dropdown.Item
                onClick={() => navigate(`/expense-purchase-order/${props.data.id}/edit`)}
              >
                {'แก้ไข'}
              </Dropdown.Item>
            )}
            {can('accounting_purchase_order_edit') && (
              <Dropdown.Item className='text-danger' onClick={handleCancelDocument}>
                {'ยกเลิกเอกสาร'}
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
          {dialogElement}
        </Dropdown>
      )
    case IncomeDocumentStateTypes.PARTIAL:
    case IncomeDocumentStateTypes.APPROVED:
      return (
        <Dropdown>
          <Dropdown.Toggle
            as='a'
            bsPrefix=' '
            className='btn btn-light btn-active-light-primary btn-sm d-inline-flex align-items-center gap-1'
          >
            Actions
            <KTIcon iconName='down' className='fs-5 m-0' />
          </Dropdown.Toggle>
          <Dropdown.Menu renderOnMount popperConfig={{strategy: 'fixed'}}>
            <Dropdown.Item
              disabled={!can('accounting_purchase_record_create')}
              onClick={() => checkPurchaseInventoryRecord(props.data.id)}
            >
              {'บันทึกซื้อสินค้า'}
            </Dropdown.Item>
            <Dropdown.Item
              disabled={!can('accounting_deposit_payment_create')}
              onClick={() => navigate(`/expense-deposit-payment/create?docId=${props.data.id}`)}
            >
              {'สร้างใบจ่ายเงินมัดจำ'}
            </Dropdown.Item>
            {can('accounting_purchase_order_edit') && (
              <Dropdown.Item className='text-danger' onClick={handleCancelDocument}>
                {'ยกเลิกเอกสาร'}
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      )
    case IncomeDocumentStateTypes.COMPLETELY:
      return (
        <>
          {can('accounting_purchase_order_edit') && (
            <Button
              size={'sm'}
              variant={'danger'}
              onClick={handleCancelDocument}
            >
              {'ยกเลิกเอกสาร'}
            </Button>
          )}
        </>
      )
  }

  return <StateLabel state={props.data.state} />
}

export default StateActionGroup
